// Lee el detalle de la venta del portal, que es el único que trae `cancellation`.
import { useQuery } from '@tanstack/react-query';
import { wizardApi } from '@/api/services/retail-wizard';
import type { SaleCancellation } from '@/api/services/retail-wizard/contract';
import type { SaleDetailStatus } from '@/shared/patterns/CancelSale';
import { PORTAL_KEYS } from '../../api/usePortal';

/** Cuelga de `recentSales` para que la cancelación exitosa también lo relea. */
export function portalSaleDetailKey(saleId: string) {
    return [...PORTAL_KEYS.recentSales, 'detail', saleId] as const;
}

export interface PortalSaleCancellation {
    cancellation: SaleCancellation | undefined;
    status: SaleDetailStatus;
}

export function usePortalSaleCancellation(saleId: string): PortalSaleCancellation {
    const query = useQuery({
        queryKey: portalSaleDetailKey(saleId),
        queryFn: () => wizardApi.getSale(saleId),
        select: (sale) => sale.cancellation,
        retry: false,
        staleTime: 30_000,
    });
    return { cancellation: query.data, status: query.status };
}
